module.exports = __webpack_public_path__ + "static/img/preview-07.7872bb0b.webp";